import cn from "classnames";
import { Dispatch, SetStateAction } from "react";
import "./partner-item.sass";

type Props = {
  img: string;
  index: number;
  setHover: Dispatch<SetStateAction<number | undefined>>;
  hover: number | undefined;
};

const PartnerItem = ({ img, index, setHover, hover }: Props) => {
  const isActive = () => {
    return hover === index;
  };

  const isNotActive = () => {
    if (!hover) {
      return false;
    }

    return hover !== index;
  };

  return (
    <div
      className={cn(
        "patner-item",
        { _activeItem: isActive() },
        { _notActiveItem: isNotActive() },
      )}
      onMouseEnter={() => setHover(index)}
      onMouseLeave={() => setHover(undefined)}
    >
      <img src={img} className="patner-item__img" alt="" />
    </div>
  );
};

export default PartnerItem;
